import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CaptureProfilePanel } from '../../CaptureProfilePanel';
import { CaptureTasksPanel } from '../../CaptureTasksPanel';
import { CaptureTeamPanel } from '../../CaptureTeamPanel';
import { HypothesisCard } from '../../HypothesisCard';
import { useCaptureWorkspace, usePursuitOpening } from '../../hooks';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/**
 * Profile & plan (Working papers; legacy `?tab=overview`): hypothesis, capture
 * profile, team and action plan. The anchor ids pursuit-profile / pursuit-team
 * / pursuit-plan are kept for `outputOwner` and Overview deep links.
 */ export function PlanSection() {
    const { captureProjectId, correlationId } = usePursuitRecord();
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    const { data } = useCaptureWorkspace(captureProjectId);
    const { data: opening } = usePursuitOpening(captureProjectId);
    const summary = data?.summary;
    const [params] = useSearchParams();
    const outputOwner = params.get('outputOwner');
    // Outputs hands a section back to its owner panel (`outputOwner=pursuit-profile`, …), as the tab did.
    useEffect(()=>{
        if (!outputOwner || !summary) return;
        const element = document.getElementById(outputOwner);
        if (!element) return;
        element.tabIndex = -1;
        element.focus({
            preventScroll: true
        });
        element.scrollIntoView({
            block: 'start'
        });
    }, [
        outputOwner,
        summary
    ]);
    return /*#__PURE__*/ _jsxs(PursuitSectionFrame, {
        title: "Profile & plan",
        children: [
            summary && /*#__PURE__*/ _jsx(HypothesisCard, {
                readOnly: !canEdit,
                captureProjectId: captureProjectId,
                summary: summary
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "pursuit-profile",
                children: /*#__PURE__*/ _jsx(CaptureProfilePanel, {
                    readOnly: !canEdit,
                    captureProjectId: captureProjectId,
                    competitionLinks: data?.competitionLinks ?? [],
                    correlationId: correlationId,
                    opportunityId: opening?.opportunityId ?? '',
                    profile: data?.profile,
                    pursuitName: summary?.name ?? '',
                    qualificationId: opening?.qualificationId ?? ''
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "pursuit-team",
                children: /*#__PURE__*/ _jsx(CaptureTeamPanel, {
                    readOnly: !canEdit,
                    captureProjectId: captureProjectId
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "pursuit-plan",
                children: /*#__PURE__*/ _jsx(CaptureTasksPanel, {
                    readOnly: !canEdit,
                    captureProjectId: captureProjectId,
                    correlationId: correlationId,
                    tasks: data?.tasks ?? []
                })
            })
        ]
    });
}
